import React from "react";

/**
 * ThemeToggle — iter-101 HIDDEN for MVP. Light theme isn't optimized yet;
 * shipping with a half-broken visual treatment is worse than not offering
 * the choice. Component now renders nothing. Re-enable by reverting this
 * file to the previous version.
 */
export default function ThemeToggle() {
    return null;
}
